import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Materiales } from '../../core/model/materiales';
import { SolicitudMateriales } from '../../core/model/solicitud-materiales';

@Injectable()
export class MaterialesService {
  MATERIAL_PATH: string;
  constructor(private http: HttpClient) {
    this.MATERIAL_PATH = environment.API_BASE + '/Materials';
  }

  getMaterialsByClient(clientId: number): Observable<Materiales[]> {
    return this.http.get<Materiales[]>(this.MATERIAL_PATH + '/' + clientId)
      .pipe(map(response => response.map(respon => Materiales.toModel(JSON.stringify(respon)))));
  }

}
